import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Header from "../HeaderFooter/Header";
import Footer from "../HeaderFooter/Footer";
import { fetchProjectById } from "../../services/API";
import "../../styles/projectStyles/ProjectDetails.css";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

const ProjectDetails = () => {
  localStorage.removeItem("projectDescription");
  localStorage.removeItem("selectedTasks");
  localStorage.removeItem("dateRanges");
  localStorage.removeItem("uploadedFiles");
  dayjs.extend(utc);
  dayjs.extend(timezone);

  const { id } = useParams();
  const navigate = useNavigate();

  const [projectData, setProjectData] = useState({});
  const [tasks, setTasks] = useState([]);
  const [timeframe, setTimeframe] = useState({});
  const [attachments, setAttachments] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchProjectDetails = async () => {
      try {
        console.log("Project id ", id);

        const response = await fetchProjectById(id);

        if (response && response.data) {
          const { ProjectData, Tasks, Timeframe, Attachments } = response.data;

          setProjectData(ProjectData);
          setTasks(Tasks);
          setTimeframe(Timeframe[0]);
          setAttachments(Attachments);
        } else {
          console.error("Invalid project data received.");
        }
      } catch (error) {
        console.error("Error fetching project details:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchProjectDetails();
  }, [id]);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!projectData.PROJECT_ID) {
    return <div>Error: Project not found</div>;
  }

  const files = [
    {
      image: "/images/doc.svg",
      name: "Construction Doc 1",
      size: "2mb",
      progress: 70,
    },
    {
      image: "/images/video.svg",
      name: "Construction Video 2",
      size: "20mb",
      progress: 25,
    },
    {
      image: "/images/image.svg",
      name: "Construction Image 3",
      size: "5mb",
      progress: 40,
    },
    {
      image: "/images/doc.svg",
      name: "Construction Doc 4",
      size: "2mb",
      progress: 95,
    },
  ];

  const openGoogleMaps = (address) => {
    const encodedAddress = encodeURIComponent(address);
    const mapsUrl = `https://www.google.com/maps?q=${encodedAddress}`;
    window.open(mapsUrl, "_blank");
  };

  const handleEditBtn = () => {
    localStorage.removeItem("projectDescription");
    localStorage.removeItem("selectedTasks");
    localStorage.removeItem("dateRanges");
    localStorage.removeItem("uploadedFiles");

    const projectTrfData = {
      address: projectData.Address || "",
      housecode: projectData.Post_Code || "",
      phoneNumber: projectData.Contact_Phone || "",
      email: projectData.Contact_Email || "",
      overview: projectData.Project_Description || "",
    };
    localStorage.setItem("projectDescription", JSON.stringify(projectTrfData));
    console.log(id);
    localStorage.setItem("projectId", id);
    console.log("Proj data", tasks);
    const selectedTasksTrf = tasks.map((task, index) => ({
      taskid: task.Task_ID,
      taskname: task.Task_Name,
      subtasklist: task.Subtasks?.map((subtask) => ({
        value: subtask.Subtask_ID || "",
        label: subtask.Subtask_Name,
      })),
      employeelist: task.Employees?.map((employee) => ({
        value: employee.Employee_Assigned,
        label: employee.Employee_Name,
      })),
    }));
    localStorage.setItem("selectedTasks", JSON.stringify(selectedTasksTrf));

    function formatDateString(dateString) {
      console.log("Date before edit", dateString);
      const formattedDate =
        dayjs.utc(dateString).format("YYYY-MM-DDTHH:mm:ss.SSS") + "-05:00";
      console.log("Date after edit", formattedDate);
      return formattedDate;
    }
    function formatToStartTime(dateString) {
      const date = new Date(dateString);

      // Format the time without changing the original time
      return date.toLocaleTimeString("en-US", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
        timeZone: "UTC", // Ensure the time is not shifted
      });
    }
    console.log("taskkkss", JSON.stringify(tasks));
    const transformedEmployees = tasks.reduce((acc, task) => {
      // Ensure the task ID exists in the accumulator
      if (!acc[task.Task_ID]) {
        acc[task.Task_ID] = {};
      }

      // Iterate over each employee and map their date ranges
      task.Employees.forEach((employee, employeeIndex) => {
        if (!acc[task.Task_ID][employeeIndex]) {
          acc[task.Task_ID][employeeIndex] = [];
        }

        // Push the transformed employee date range
        acc[task.Task_ID][employeeIndex].push({
          startDate: formatDateString(employee.Time_Start),
          endDate: formatDateString(employee.Time_Finish),
          startTime: formatToStartTime(employee.Time_Start),
        });
      });

      return acc;
    }, {});

    console.log(JSON.stringify(transformedEmployees, null, 2));

    console.log(JSON.stringify(transformedEmployees));

    console.log("transformedEmployees", transformedEmployees);
    localStorage.setItem("dateRanges", JSON.stringify(transformedEmployees));
    console.log("selectedTasksTrf", selectedTasksTrf);
    navigate("/addproject");
  };

  const startDate = new Date(timeframe["MIN(Time_Start)"]).toLocaleDateString();
  const endDate = new Date(timeframe["MAX(Time_Finish)"]).toLocaleDateString();

  return (
    <div className="details-project-container">
      <Header />
      <div className="project_details">
        <div className="det-container">
          <h2 className="project-details-title">Project Details</h2>
          <div className="detail">
            <button
              className="detail-item"
              onClick={() => navigate("/projects")}
            >
              <img src="/images/back.svg" alt="Back" className="tab-icon" />
              Back to Projects
            </button>
            <img
              src="/images/Rectangle.png"
              alt="Separator"
              className="rectan-icon"
            />
          </div>
        </div>
      </div>

      <div className="detailScreen">
        <div className="project-date-card">
          <div className="date-section">
            <div className="date">
              <p className="date-label">Start Date</p>
              <p className="date-value">{startDate}</p>
            </div>
            <div className="date">
              <p className="date-label">End Date</p>
              <p className="date-value">{endDate}</p>
            </div>
          </div>
          <div className="status-section">
            <span className="status-icon">
              <img src="/images/progress.png" alt="Status Icon" />
            </span>
            <span className="status-text">{projectData.Status}</span>
          </div>
        </div>

        <div className="pro-details-container">
          <div className="address-container">
            <h3 className="pro-title">{projectData.Address}</h3>
            <button
              className="edit-btn"
              onClick={() => handleEditBtn(projectData.PROJECT_ID)}
            >
              <img src="/images/edit.png" alt="Edit" className="edit-icon" />
              Edit
            </button>
          </div>

          <div className="pro-container">
            <div className="pro-desc-container">
              <h3 className="prodesc-title">Project Description</h3>
              <div className="prodetails-container">
                <div className="details-wrapper">
                  <table className="prodet-table">
                    <thead>
                      <tr>
                        <th>House Details</th>
                        <th></th>
                        <th className="spc" colSpan={2}>
                          Contact Details
                        </th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>Address</strong>
                          <br />
                          {projectData.Address}
                        </td>
                        <td>
                          <strong>House Code</strong>
                          <br />
                          {projectData.Post_Code}
                        </td>
                        <td>
                          <strong>Phone Number</strong>
                          <br />
                          {projectData.Contact_Phone}
                        </td>

                        <td>
                          <strong>Email Address</strong>
                          <br />
                          {projectData.Contact_Email}
                        </td>
                      </tr>
                      <tr>
                        <td colSpan="2">
                          <h3 className="overview">Project Overview</h3>
                          <p>{projectData.Project_Description}</p>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <div className="taskanddates-detail-container">
              <h3 className="prodesc-title">Task and Dates</h3>
              <div className="prodetails-container">
                <table className="taskdate-table">
                  <tbody>
                    {tasks.map((task, index) => (
                      <React.Fragment key={index}>
                        {/* Task Name Row */}
                        <tr className="task-title">
                          <td colSpan="3">{task.Task_Name}</td>
                        </tr>

                        {/* Task Details Row */}
                        <tr>
                          <td className="task-details">
                            {task.Subtasks.length > 0 ? (
                              <div className="subtasks-container">
                                {task.Subtasks.map((subtask, subIndex) => (
                                  <div key={subIndex} className="subtask-item">
                                    {subtask.Subtask_Name}
                                  </div>
                                ))}
                              </div>
                            ) : (
                              <p>No subtasks assigned</p>
                            )}
                          </td>

                          <td colSpan="2">
                            {task.Employees.map((employee, i) => (
                              <div key={i} className="task-row">
                                <span className="employeeNameSpan">
                                  {employee.Employee_Name}
                                </span>
                                <span className="date-range">
                                  {new Date(
                                    employee.Time_Start
                                  ).toLocaleDateString()}{" "}
                                  -{" "}
                                  {new Date(
                                    employee.Time_Finish
                                  ).toLocaleDateString()}
                                </span>
                                <span className="time">
                                  {new Date(
                                    employee.Time_Start
                                  ).toLocaleTimeString([], {
                                    hour: "2-digit",
                                    minute: "2-digit",
                                  })}
                                </span>
                                <img
                                  src="/images/location.png"
                                  alt="Location Icon"
                                  className="location-icon"
                                  onClick={() =>
                                    openGoogleMaps(projectData.Address)
                                  }
                                />
                              </div>
                            ))}
                          </td>
                        </tr>
                        {/* Horizontal Line */}
                        <tr className="separator-row">
                          <td colSpan="3" className="separator"></td>
                        </tr>
                      </React.Fragment>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
            <div className="additionaldet-container">
              <h3 className="prodesc-title">Additional Details</h3>
              <div className="additionaldetls">
                <h3 className="attach">Attachments</h3>
                <div className="file-list">
                  {files.length > 0 ? (
                    files.map((file, index) => (
                      <div key={index} className="file-item">
                        <img
                          src={file.image || "images/doc.svg"}
                          alt={`${file.name} preview`}
                          className="file-preview"
                        />
                        <span className="file-name">{file.name}</span>
                        <span className="file-size">{file.size}</span>
                        <img
                          src="/images/downloads.png"
                          alt="Download Icon"
                          className="location-icon"
                        />
                      </div>
                    ))
                  ) : (
                    <p>No files uploaded</p>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ProjectDetails;
